import { combineReducers } from 'redux';
import persistedMultiCart from 'flaivy-react/reducers/persisted-multi-cart.reducer';
import checkout from 'flaivy-react/reducers/checkout.reducer';
import authentication from 'flaivy-react/reducers/auth.reducer';
import loginModal from './login-modal.reducer';
import shopConfig from './shop-config.reducer';
import myFavoriteArticles from './my-favorite-articles.reducer';
import orderDetailsPage from './orderDetailsPage.reducer';

const rootReducer = combineReducers({
  orderDetailsPage,
  authentication,
  persistedMultiCart,
  loginModal,
  shopConfig,
  myFavoriteArticles,
  checkout,
});

export default rootReducer;
